import { useMemo } from 'react';

import { ValidationItems } from '@kanda-libs/ks-component-ts';

import { AddressManualWidgets, BASE_WIDGETS } from './constants';

import { useAddressFieldContext } from '../../context';

export interface AddressManualHook {
  show: boolean;
  widgets: AddressManualWidgets;
  buildingValidation: ValidationItems;
  postcodeName: string;
  postcodeValidation: ValidationItems;
  onPostcodeBlur: () => void;
}

export default function useAddressManual(): AddressManualHook {
  const {
    manual,
    addressType,
    buildingValidation,
    postcodeName,
    postcodeValidation,
    onPostcodeBlur,
  } = useAddressFieldContext();

  const widgets = useMemo(() => BASE_WIDGETS[addressType], [addressType]);

  return {
    show: manual,
    widgets,
    buildingValidation,
    postcodeName,
    postcodeValidation,
    onPostcodeBlur,
  };
}
